import React from 'react'
import EventDetails from '../AdminEventDetails/EventDetails'
import Grid from '@material-ui/core/Grid'
import {defaultGridSettings} from '../../../../js/settings/grid'
const AdminConfirmedEventDetails = (props) =>{

    return (
        <Grid container {...defaultGridSettings.contianer} >
            <Grid item {...defaultGridSettings.item} >
                <EventDetails openEvent={props.event} />
            </Grid>
        </Grid>
    )
}

export default AdminConfirmedEventDetails


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminConfirmedEvents/AdminConfirmedEventDetails.js